import * as ArgusUtils from "@mnemonic/pure-utils/ArgusUtils";
import { initializeIntl, initializeSession } from ".";
import initializeLogging from "./initilizeLogging";
export default async function PromiseBootstrap() {
    const target = ArgusUtils.getTargetMeta();
    const session = await initializeSession(target);
    const intl = await initializeIntl(session);
    await initializeLogging(session, target);
    return { session, intl };
}
